const Blockly = require('blockly');
const dataAccessMethods = require('../../../../dataAccessMethods');
const mdcConfig = require('@sstdev/lib_metadata-config');
const setupAddCodeProperties = require('../../../../helpers/addCodeProperties');
const convertToBoolean = require('../../../../helpers/convertToBoolean');
const { config } = mdcConfig;

const TOOLTIP = 'Dialog component which displays an RFID powerslider';
/**
 * @param {*} color
 * @param {import('blockly').Block} blocklyBlock
 */
function addBlockSpecificFields(color, blocklyBlock, mdcBlock, line1OfInputs) {
    let workspace = blocklyBlock.workspace;
    let blockId = blocklyBlock.id;
    blocklyBlock.setTooltip(TOOLTIP);
    //set inputs to be arranged vertically.
    //Meaning each (dummy)input starts a new line
    blocklyBlock.setInputsInline(false);

    line1OfInputs
        .appendField('Display Mode:')
        .appendField(
            new Blockly.FieldDropdown(() => [
                ['Include Button to Trigger Dialog', 'button'],
                ['Dialog Displayed By Event', 'event']
            ]),
            'displayMode'
        )
        .appendField('  Display a Scan Button:')
        .appendField(new Blockly.FieldCheckbox(), 'displayScanButton');

    const line2OfInput = blocklyBlock
        .appendDummyInput()
        .appendField('  Triggering Event --  Namespace:')
        .appendField(new Blockly.FieldDropdown(dataAccessMethods.getNamespaces), 'namespace')
        .appendField('  Relation:')
        .appendField(new Blockly.FieldDropdown(() => dataAccessMethods.getRelations(workspace, blockId)), 'relation');

    // Load possible actions and default action
    const actionsDropdown = new Blockly.FieldDropdown(config.actionElementActions);
    actionsDropdown.setValue('open');
    const subtypeTextField = new Blockly.FieldTextInput('PowerSliderPopup');
    line2OfInput
        .appendField('  For Action:')
        .appendField(actionsDropdown, 'forAction')
        .appendField('  (optional) Subtype:')
        .appendField(subtypeTextField, 'subtype');
}

/**
 * @param {{[key: string]: any}} code
 * @param {import('blockly').Block} blocklyBlock
 * @return {{[key: string]: any}}
 */
function convertCustomFieldsToCode(code, blocklyBlock) {
    const addCodeProperties = setupAddCodeProperties(code, blocklyBlock);
    addCodeProperties(['displayMode', 'namespace', 'relation', 'forAction', 'subtype']);
    addCodeProperties([{ key: 'displayScanButton', handler: convertToBoolean }]);
    return code;
}
module.exports = { addBlockSpecificFields, convertCustomFieldsToCode };
